export default {
    data() {
        return {
            active: null
        }
    },
    methods: {
    handleEnter(id) {
      this.active = id;
    },
    handleLeave(id) {
      // wait a bit in case the user gets to the next section
      if (this.active === id) {
        const oldId = this.active;
        setTimeout(() => {
          if (oldId === this.active) {
            this.active = null;
          }
        }, 1000);
      }
    },
  },
}